export default "__VITE_ASSET__DlM5wmh9__"